import Vue from 'vue';
import Router from 'vue-router';
import {
  getUserInfo,
} from '../services/getData';
import store from '@/store/index';
import {
  CURRENTUSER,
  AUTHORITY,
} from '@/store/types';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes: [{
      path: '/',
      name: 'index',
      component: () => import('../views/home/Home.vue'),
      redirect: '/login',
      children: [
        {
          path: 'exam',
          name: 'exam',
          component: () => import('../views/examPaper/ExamPaper.vue'), // lazy loading(loading only when direct to the path) and split code entrance
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'minecraft',
          name: 'minecraft',
          component: () => import('../views/home/ide/Mc.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'mockExam',
          name: 'mockExam',
          component: () => import('../views/examPaper/MockExam.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'grade',
          name: 'grade',
          component: () => import('../views/examPaper/GradePaper.vue'),
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: '/user',
      name: 'user',
      component: () => import('../views/user/User.vue'),
      redirect: '/user/myExam',
      children: [
        {
          path: 'myExam',
          name: 'myExam',
          component: () => import('../views/user/MyExam.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'myFace',
          name: 'myFace',
          component: () => import('../views/user/Face.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'deviceTest/:step',
          name: 'deviceTest',
          component: () => import('../views/user/DeviceTest.vue'),
          meta: {
            requiresAuth: true,
          },

        },
        {
          path: 'resetPassword/:step',
          name: 'resetPassword',
          component: () => import('../views/user/ResetPassword.vue'),
        },
        {
          path: 'editPassword',
          name: 'editPassword',
          component: () => import('../views/user/EditPassword.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'testFace',
          name: 'testFace',
          component: () => import('../views/login/Face.vue'),
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: '/login',
      name: 'loginIndex',
      component: () => import('../views/login/Index.vue'),
      children: [{
          path: '/',
          name: 'login',
          component: () => import('../views/login/Login.vue'),
        },
        {
          path: 'face',
          name: 'Face',
          component: () => import('../views/login/Face.vue'),
        },
      ],
    },
    // {
    //   path: '/python',
    //   name: 'python',
    //   component: () => import('../views/ide/Python.vue'),
    // },
    {
      path: '/preview',
      name: 'preview',
      component: () => import('../views/ide/Index.vue'),
      children: [
        {
          path: 'python',
          name: 'python',
          component: () => import('../views/ide/Python.vue'),
        },
        {
          path: 'minecraft',
          name: 'minecraft',
          component: () => import('../views/ide/MineCraft.vue'),
        },
      ],
    },
  ],
});
router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) { // 当地址错误无法匹配时跳转到首页
    from.name ? next({
      name: from.name,
    }) : next('/');
  } else {
    next();
  }
  if (to.matched.some(r => r.meta.requiresAuth)) {
    if (store.state.currentUser && store.state.currentUser.id) {
      next();
    } else {
      console.log('before getuserinfo');
      if (!store.state.authority) {
        const rawAuthority = localStorage.getItem('authority');
        store.commit(AUTHORITY, JSON.parse(rawAuthority));
      }
      getUserInfo().then((response) => {
        const userInfo = response.data;
        store.commit(CURRENTUSER, userInfo);
        localStorage.setItem('currentUser', JSON.stringify(userInfo));
      }).catch((error) => {
        console.log(error);
      });
    }
  } else {
    next();
  }
});

export default router;
